import type { PinFutureContractFormValues } from "web_myplann/Goals/Hooks/usePinFutureContractForm";
import { FuturePortfolioTypeEnum } from "web_myplann/Infrastructure/Api/Api";

export const isLoanFutureType = (type: FuturePortfolioTypeEnum) =>
	type === FuturePortfolioTypeEnum.Mortgage ||
	type === FuturePortfolioTypeEnum.Loan;

export const getAmounts = (values: PinFutureContractFormValues) =>
	isLoanFutureType(values.type)
		? { oneTimeDeposit: values.loanAmount || null, monthlyAmount: null }
		: {
				oneTimeDeposit: values.lumpSum || null,
				monthlyAmount: values.monthly || null,
			};
